import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PublicCourse from '../publicCourse/PublicCourse'
import { getCoursesGroup } from '../../../app/slices/courseSlice'

const BoughtCoursesCard = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCoursesGroup())
  }, [])

  return (
    <div>
      <PublicCourse bought />
    </div>
  )
}

export default BoughtCoursesCard
